import { GetProductUrl } from '@app/logic/products';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { Product as ProductType } from '@typings';
import React from 'react';

import { Product } from '../ProductCard';
import { ProductLine } from '../ProductLine';

interface Props {
  showGridView: boolean;
  product: ProductType.Full;
  getProductUrl: GetProductUrl;
}

export const ProductsListItem = React.memo(({ showGridView, product, getProductUrl }: Props) => {
  const { trackEvent } = useAmplitude();
  const handleProductTracking = () => {
    trackEvent({ name: 'listing.button.addtoselection.click' });
  };

  if (showGridView) {
    return <Product productInfo={product} getProductUrl={getProductUrl} onAddToSelection={handleProductTracking} />;
  }

  return <ProductLine productInfo={product} />;
});
